import React, { ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';

interface PermissionGuardProps {
  claim: string;
  children: ReactNode;
  fallback?: ReactNode;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({ claim, children, fallback = null }) => {
  const { hasPermission } = useAuth();
  return hasPermission(claim) ? <>{children}</> : <>{fallback}</>;
};

export default PermissionGuard;
